/* tslint:disable */
/* eslint-disable */
/**
 * data-center
 * data-center
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DataCenterCategory = {
    Referrals: 'Referrals',
    Census: 'Census',
    Workflow: 'Workflow',
    Reimbursement: 'Reimbursement',
    Discharge: 'Discharge',
    ExecReporting: 'Exec Reporting',
} as const;
export type DataCenterCategory = typeof DataCenterCategory[keyof typeof DataCenterCategory];


export function instanceOfDataCenterCategory(value: any): boolean {
    for (const key in DataCenterCategory) {
        if (Object.prototype.hasOwnProperty.call(DataCenterCategory, key)) {
            if (DataCenterCategory[key as keyof typeof DataCenterCategory] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DataCenterCategoryFromJSON(json: any): DataCenterCategory {
    return DataCenterCategoryFromJSONTyped(json, false);
}

export function DataCenterCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataCenterCategory {
    return json as DataCenterCategory;
}

export function DataCenterCategoryToJSON(value?: DataCenterCategory | null): any {
    return value as any;
}

export function DataCenterCategoryToJSONTyped(value: any, ignoreDiscriminator: boolean): DataCenterCategory {
    return value as DataCenterCategory;
}

